import React from 'react';
import SEOHead from '../../components/seo/seo-head';
import { SEO_CONFIG } from '../../constants/seo-config';
import AppStore from '../../stores/stores';

import LoginStore from '../../stores/login-store';
import AuthMixin from '../../mixins/authenticationMixin';
import MarketingHero from '../../components/homepage/marketing-hero';
import MarketingTrustBar from '../../components/homepage/marketing-trust-bar';
import MarketingFeatures from '../../components/homepage/marketing-features';
import MarketingHowItWorks from '../../components/homepage/marketing-how-it-works';
import MarketingCapabilities from '../../components/homepage/marketing-capabilities';
import MarketingPublications from '../../components/homepage/marketing-publications';
import MarketingTestimonials from '../../components/homepage/marketing-testimonials';
import MarketingSubscribe from '../../components/homepage/marketing-subscribe';


class HomePage extends React.Component {
  constructor() {
    super();
    this.state = {
      recentlyUpdated: [],
      recentSearches: [],
      popularSearches: [],
      popularCategories: [],
      newsItems: [],
    };

    this.loadHomeData = this.loadHomeData.bind(this);
    this.loadSubstackPosts = this.loadSubstackPosts.bind(this);
    this.initReveal = this.initReveal.bind(this);
  }

  componentDidMount() {
    this.loadHomeData();
    this.loadSubstackPosts();
    this.initReveal();
  }

  componentDidUpdate() {
    this.initReveal();
  }

  initReveal() {
    const reveals = document.querySelectorAll('.reveal:not(.visible)');
    if ('IntersectionObserver' in window) {
      const io = new IntersectionObserver((entries) => {
        entries.forEach(e => {
          if (e.isIntersecting) {
            e.target.classList.add('visible');
            io.unobserve(e.target);
          }
        });
      }, { threshold: 0.12 });
      reveals.forEach(el => io.observe(el));
    } else {
      reveals.forEach(el => el.classList.add('visible'));
    }
  }

  loadHomeData() {
    AppStore.loadHomepage(this.props.userApiRequest, {
      onSuccess: ({ data }) => {
        this.setState({
          recentlyUpdated: data.recently_updated,
          recentSearches: data.recent_searches,
          popularSearches: data.popular_searches,
          popularCategories: data.popular_categories
        });
      },
      onError: () => { }
    });
  }

  loadSubstackPosts() {
    AppStore.getSubstackPosts({
      onSuccess: ({ data }) => {
        this.setState({
          newsItems: data.posts || []
        });
      },
      onError: () => {
        this.setState({
          newsItems: []
        });
      }
    });
  }

  render() {
    return (
      <div className="new-homepage-wrapper">
        <SEOHead {...SEO_CONFIG.homepage} />
        <MarketingHero {...this.props} {...this.state} />
        <MarketingTrustBar />
        <MarketingPublications recentlyPublished={this.state.recentlyUpdated} popularCategories={this.state.popularCategories} newsItems={this.state.newsItems} />
        <MarketingFeatures />
        <MarketingHowItWorks />
        <MarketingCapabilities />
        {LoginStore.isLoggedIn() ? '' : <MarketingTestimonials />}
        <MarketingSubscribe />
      </div>
    );
  }
}

export default AuthMixin(HomePage);
